import { AXTranslationService } from '@acorex/core/translation';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { HotelWlLayoutComponent } from '@travel/hotel-wl-layout';
import { PlatformService } from '@travel/shared/services';

export function mainRoute(lang: string) {
  const routes: Routes = [
    {
      path: lang,
      component: HotelWlLayoutComponent,
      children: [
        {
          path: '',
          loadChildren: () => import('@travel/hotel-wl-home').then((m) => m.HotelWlHomeModule),
        },
        {
          path: 'reservation',
          loadChildren: () => import('@travel/hotel-wl-hotel').then((m) => m.HotelWlHotelModule),
        },
        // {
        //   path: 'login',
        //   // component: LoginLayout,
        //   loadChildren: () => import('@travel/login').then((m) => m.LoginModule),
        // },
        {
          path: 'about-us',
          loadComponent: () => import('@travel/tport-wl-about-us').then((m) => m.TportWlAboutUsComponent),
        },
        {
          path: 'reserve',
          loadComponent: () => import('@travel/tport-wl-reserve').then((m) => m.TportWlReserveComponent),
        },
        {
          path: 'reserve-bank',
          loadComponent: () => import('@travel/tport-wl-reserve-pay').then((m) => m.TportWlReservePayComponent),
        },
        {
          path: 'reserve-confirm',
          loadComponent: () => import('@travel/public-reserve-confirm').then((m) => m.PublicReserveConfirmComponent),
        },
        {
          path: 'reserve-booked',
          loadComponent: () => import('@travel/public-reserve-confirm').then((m) => m.PublicReserveConfirmComponent),
        },
        {
          path: 'reserve-failed',
          loadComponent: () => import('@travel/public-reserve-failed').then((m) => m.PublicReserveFailedComponent),
        },
        {
          path: 'contact',
          loadComponent: () => import('@travel/tport-wl-contact').then((m) => m.TportWlContactComponent),
        },
        {
          path: 'policy',
          loadComponent: () => import('@travel/tport-wl-policy').then((m) => m.TportWlPolicyComponent),
        },
        // {
        //   path: 'account',
        //   canActivate: [ActiveUser],
        //   loadChildren: () => import('@travel/account').then((m) => m.AccountModule),
        // },
        {
          path: 'account',
          loadChildren: () => import('@travel/public-account').then((m) => m.PublicAccountModule),
        },
        {
          path: '**',
          loadComponent: () => import('@travel/public-not-found').then((mod) => mod.PublicNotFoundComponent),
        },
      ],
    },
    // ,
    // { path: '', pathMatch: 'full', redirectTo: '/fa' }
  ];
  return [...routes];
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  _httpClient = inject(HttpClient);
  _translation = inject(AXTranslationService);
  constructor(private injector: Injector, private _platform: PlatformService, private _location: Location) {}

  public load() {
    return new Promise((resolve) => {
      this._platform.setDefaultLang().then((lang) => {
        if (this._platform.getUrl()[1] === '') {
          resolve(this.setLanguage(lang));
        } else {
          resolve(this.setLanguage(this._platform.siteLanguage()));
        }
      });
    });
  }

  setLanguage(lang: string) {
    switch (lang) {
      case 'fa':
        this._translation.setActiveLang('fa');

        document.body.dir = 'rtl';
        document.documentElement.setAttribute('dir', 'rtl');
        break;
      case 'ar':
        this._translation.setActiveLang('ar');
        document.body.dir = 'rtl';
        document.documentElement.setAttribute('dir', 'rtl');
        break;
      case 'en':
        this._translation.setActiveLang('en');
        document.body.dir = 'ltr';
        document.documentElement.setAttribute('dir', 'ltr');
        break;

      default:
        break;
    }

    const routes = [...mainRoute(lang)];
    const router = this.injector.get(Router);
    router.resetConfig(routes);
    const curentUrl = this._location.path();

    const newUrl = curentUrl.replace(this._platform.siteLanguage(), `/${lang}`);
    router.navigateByUrl(newUrl);
    return routes;
  }
}
